// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Moev","title":"styles_title__3eUz8"};